import api from '../utils/api';

export const getAllWorkflows = (config) => {
  return api().get('/workflow/', config);
};

export const getWorkflow = (id, params) => {
  return api().get(`/workflow/${id}/`, { params });
};
